// extracted by css-extract-rspack-plugin
export default {"registerPageRoot":"rC2Um6"};